export default "__VITE_ASSET__AO2Y_tiJ__"